import { createReducer } from '../../../../store.model';
import { ActionType } from '../main.action';

import { defaultState, MainState } from './main.state';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
const { reducer, builder } = createReducer<ActionType, MainState>(
    defaultState(),
);

builder
    .add<Reload>(ActionType.WP_MAIN__RELOAD, reloadReducer)
    .add<ReloadResult>(ActionType.WP_MAIN__RELOAD_RESULT, reloadResultReducer);
export const mainReducer = reducer;
